// extracted by mini-css-extract-plugin
module.exports = {"avatarGroup":"AvatarGroup_avatarGroup__c29Wo","avatar":"AvatarGroup_avatar__wBXXS"};